import { useEffect, useState } from 'react';

import { ALLOWED_FILTER_KEY } from 'Lib/constants/page';
import Container from 'Components/Container';
import EndOfList from './EndOfList';
import FilterSelect from './FilterSelect';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadMoreSpinner from 'Components/SpinnerLoader/LoadMoreSpinner';
import ProductFilter from './ProductFilter';
import ProductSection from 'Components/Product/ProductSection';
import SortSelect from './SortSelect';
import client from 'Lib/ApolloClient';
import { productsMoreQuery } from 'Lib/query-param';
import { useRouter } from 'next/router';

export default function ProductList(props) {
  const router = useRouter();
  const { products, pageMeta, pageInfo } = props;
  const [loadMore, setLoadMore] = useState({ hasNextPage: false });
  const [getMoreLoading, setGetMoreLoading] = useState(false);
  const [sort, setSort] = useState(null);
  const [filter, setFilter] = useState(null);
  const [productData, setProductData] = useState([]);
  const getMoreProducts = async (pageInfo) => {
    setGetMoreLoading(true);
    const { data } = await client.query(
      productsMoreQuery(router.query, pageInfo.endCursor)
    );
    setGetMoreLoading(false);

    setLoadMore(data.products.pageInfo);
    setProductData((productData) => [...productData, ...data.products.edges]);
  };

  useEffect(() => {
    setProductData(products);
    setLoadMore(pageInfo);

    return () => {
      setProductData(null);
      setLoadMore(null);
    };
  }, [products, pageInfo]);

  const handleSortChange = (sortCrit) => {
    let sortParams = {
      [`sort[${sortCrit.value.field}]`]: sortCrit.value.order
    };
    setSort(sortCrit);

    const removedSortQuery = Object.fromEntries(
      Object.entries(router.query).filter(([key]) => !key.includes('sort'))
    );
    router.push({
      pathname: router.pathname,
      query: { ...removedSortQuery, ...sortParams }
    });
  };

  const handleFilterChange = (filterCrit) => {
    setFilter(filterCrit);
    const removedFilterQuery = Object.fromEntries(
      Object.entries(router.query).filter(
        ([key]) => ALLOWED_FILTER_KEY.indexOf(key.toUpperCase()) < 0
      )
    );
    router.push({
      pathname: router.pathname,
      query: { ...removedFilterQuery, ...filterCrit.value }
    });
  };

  return (
    <Container className="flex">
      {/* <ProductFilter /> */}      
      <Container>
        <div className="list-sort-filter fixed z-10 flex w-full bg-white pt-2 lg:hidden">
          <FilterSelect
            className="border-r"
            value={filter}
            onChange={handleFilterChange}
          />
          <SortSelect value={sort} onChange={handleSortChange} />
        </div>
        <InfiniteScroll
          dataLength={productData.length}
          next={() => getMoreProducts(loadMore)}
          loader={getMoreLoading && <LoadMoreSpinner />}
          hasMore={loadMore.hasNextPage}
          endMessage={<EndOfList />}
        >
          <div className="container flex">
            <ProductSection products={productData} title={pageMeta.name} />
          </div>
        </InfiniteScroll>
      </Container>
    </Container>
  );
}
